/**
 * 锁定滚动条位置
 */
export function lockScroll() {
  // // 保存当前滚动位置
  // const scrollPosition = window.scrollY;
  // // 锁定滚动位置
  // document.body.style.position = 'fixed';
  // document.body.style.width = '100%';
  // document.body.style.top = `-${scrollPosition}px`;
  document.body.classList.add('no-scroll')
}

/**
 * 解锁滚动条位置
 */
export function unlockScroll() {
  // // 获取当前的 top 值
  // const currentTop = document.body.style.top;
  // // 恢复滚动位置
  // document.body.style.position = '';
  // document.body.style.top = '';
  // document.body.style.width = '';
  // // 滚动到原来的位置
  // if (currentTop) {
  //     window.scrollTo(0, parseInt(currentTop || '0') * -1);
  // }
  document.body.classList.remove('no-scroll')
}
